export default __webpack_public_path__ + "static/media/On_Air_Logo.66c460d3.png";